<template>
    <div class="change-account hidden-sm-and-down">
        
        <el-dropdown @command="handleSetAccount" placement="bottom">
            <span class="el-dropdown-link">
               <i class="icon icon-change"></i>
                <span>{{$t('change_role')}}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item command="cn">
					<el-radio :label="3">运营部</el-radio>
				</el-dropdown-item>
				<el-dropdown-item command="en">
					<el-radio :label="3">研发部</el-radio>
				</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
    </div>
</template>

<script>
export default {
	name: 'change-account',
	methods: {
		handleSetAccount(role) {
			console.log(role);
		}
	}
};
</script>


<style lang="scss" scoped>
.change-account {
	padding-left: 15px;
	i {
		cursor: pointer;
	}
}
</style>
